import { type SelectBoostItem } from '../types/components';
import { type BoostType } from '../types/factoryType';

const createBoostTemplate = (
  boostType: BoostType,
  effectMultiplier: number = 2,
): SelectBoostItem => {
  const result: SelectBoostItem = {
    id: '-',
    boostType,
    plants: [],
    effectMultiplier,
  };

  if (boostType === 'Advertising') {
    result.quantity = { limit: 0, available: 0 };
  }

  return result;
};

export { createBoostTemplate };
